// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bef_a bhc_sl","StrollerBoxWidget__imageCounselling":"bef_b bhc_jz"};